import React from "react";
import { Link } from 'react-router-dom';

/* ---------------- NAVBAR COMPONENT ---------------- */
function Navbar() {
  return (
    <header style={{ position: 'fixed', top: 0, left: 0, right: 0, width: '100vw', background: '#333', color: '#fff', zIndex: 1000, display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 40px', boxSizing: 'border-box', boxShadow: '0 2px 10px rgba(0,0,0,0.2)', transition: 'background 0.3s'}}>
      <Link to="/" style={{ textDecoration: 'none', color: '#fff' }}><h1 style={{ fontSize: '22px', margin: 0 }}>Marcus Nash</h1></Link>
      <nav>        
        <Link to="/" style={{ color: '#fff', margin: '0 12px', textDecoration: 'none' }}>Home</Link>        
        <Link to="/about" style={{ color: '#fff', margin: '0 12px', textDecoration: 'none' }}>About</Link>
        <Link to="/projects" style={{ color: '#fff', margin: '0 12px', textDecoration: 'none' }}>Projects</Link>
        <Link to="/certificates" style={{ color: '#fff', margin: '0 12px', textDecoration: 'none' }}>Certificates</Link>
        <Link to="/skills" style={{ color: '#fff', margin: '0 12px', textDecoration: 'none' }}>Skills</Link>
        {/* <Link to="/contact" style={{ color: '#fff', margin: '0 12px', textDecoration: 'none' }}>Contact</Link> */}
      </nav>
    </header>
  );
}

export default Navbar
